import { DemandRoleService } from "../DemandRoleService/demand-role.service"
import { DemandRoleDelegate } from "../DemandRoleService/demand-role.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class DemandRoleServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService
    ): DemandRoleService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new DemandRoleDelegate(config, httpProvider);

        return new DemandRoleService(delegate);
    }
}